const defaultState = {}

const slideshows = (state = defaultState, action) => {
  switch (action.type) {
    case 'SLIDESHOWS_ADD':
      return {
        ...state,
        ...action.data
      }
    default:
      return state
  }
}

export default slideshows



// WEBPACK FOOTER //
// ./src/reducers/slideshows.js